import React, { Component } from "react";
import axios from 'axios';
import { withRouter } from "./withRouter";
import mapboxgl from "mapbox-gl";
import { tableFromIPC } from "apache-arrow";
import { Typography,Box,Stack,Select,FormControl, InputLabel, MenuItem,TextField, CircularProgress , Button} from "@mui/material";
import MapComponent from "./MapComponent"
import NationalVoteBar from "./NationalVoteBar"
import { alpha } from '@mui/material/styles';
import { Navigate } from "react-router-dom";

export function baseColorForLikertKey(group, key) {
  const pol = group.polarity || {};
  // Find which polarity (pos/neg/neu) corresponds to this key
  const tag = Object.entries(pol).find(([polarity, polKey]) => polKey === key)?.[0];

  
  if (tag === "pos") return "#2E7D32";
  if (tag === "neg") return "#C62828";
  return "#6e6e6e";
}
const rowsFromTable = (table) => {
  const cols = table.schema.fields.map(f => f.name);
  const rows = [];
  for (let i = 0; i < table.numRows; i++) {
    const obj = {};
    for (const c of cols) obj[c] = table.getChild(c).get(i);
    rows.push(obj);
  }
  return rows;
};

// Define party full names and official colours
// Define issue names and brighter, higher-contrast colours
const PARTY_INFO = {
  inflation_issue_n: { name: "Inflation", color: "#D98A36" },      // muted orange
  health_issue_n: { name: "Health", color: "#C23B72" },            // deep rose
  econ_issue_n: { name: "Economy", color: "#2A9FD6" },             // calm blue
  crime_issue_n: { name: "Crime", color: "#8253C8" },              // softer purple
  housing_issue_n: { name: "Housing", color: "#CC7046" },          // warm terracotta
  poverty_issue_n: { name: "Poverty", color: "#CC3333" },          // darker red
  unemployment_issue_n: { name: "Unemployment", color: "#CCB830" },// muted mustard
  climate_issue_n: { name: "Climate", color: "#2BA84A" },          // medium green
  education_issue_issue_n: { name: "Education", color: "#2B78E4" },// standard professional blue
  transport_issue_n: { name: "Transport", color: "#D1691F" },      // darker tangerine
  drugs_issue_n: { name: "Drugs", color: "#A6A832" },              // olive green
  race_rel_issue_n: { name: "Race relations", color: "#1EB7B7" },  // teal
  tax_issue_n: { name: "Tax", color: "#B94D4D" },                  // muted coral
  pollution_issue_n: { name: "Pollution", color: "#707070" },      // medium grey
  maori_issue_n: { name: "Māori", color: "#9C3E1D" },              // earthy rust
  immigration_issue_n: { name: "Immigration", color: "#C4A22E" },  // subdued gold
  defence_issue_n: { name: "Defence", color: "#335CBA" }           // classic navy blue
};


// Build labels and colors in one go
const buildLabelsAndColors = () => {
  const labels = {};
  const colors = {};

  Object.entries(PARTY_INFO).forEach(([key, info]) => {
    labels[key] = info.name;
    colors[key] = info.color;
  });

  return { labels, colors };
};


const clamp01 = (x) => Math.max(0, Math.min(1, x));
const hexToHsl = (hex) => {
  let c = hex.replace("#",""); if (c.length===3) c = c.split("").map(x=>x+x).join("");
  const r=parseInt(c.slice(0,2),16)/255, g=parseInt(c.slice(2,4),16)/255, b=parseInt(c.slice(4,6),16)/255;
  const max=Math.max(r,g,b), min=Math.min(r,g,b); let h,s,l=(max+min)/2;
  if(max===min){h=s=0;} else {const d=max-min; s=l>0.5?d/(2-max-min):d/(max+min);
    switch(max){
    case r:h=(g-b)/d+(g<b?6:0);
      break;
    case g:h=(b-r)/d+2;
      break;
    case b:h=(r-g)/d+4;
      break;
    default:
      break;
    } h/=6;}
  return {h:Math.round(h*360), s:Math.round(s*100), l:Math.round(l*100)};
};
const hslToHex = (h,s,l) => {
  h/=360; s/=100; l/=100;
  const hue2rgb=(p,q,t)=>{ if(t<0)t+=1;if(t>1)t-=1;if(t<1/6)return p+(q-p)*6*t;if(t<1/2)return q;if(t<2/3)return p+(q-p)*(2/3-t)*6;return p; };
  const q=l<0.5?l*(1+s):l+s-l*s; const p=2*l-q;
  const r=Math.round(hue2rgb(p,q,h+1/3)*255), g=Math.round(hue2rgb(p,q,h)*255), b=Math.round(hue2rgb(p,q,h-1/3)*255);
  return "#"+[r,g,b].map(v=>v.toString(16).padStart(2,"0")).join("");
};
const makeHeatScale = (baseHex, values) => {
  const finite = values.filter(v => Number.isFinite(v));
  const min = finite.length ? Math.min(...finite) : 0;
  const max = finite.length ? Math.max(...finite) : 100;
  const { h, s } = hexToHsl(baseHex);
  return (v) => {
    if (!Number.isFinite(v)) return "#CCCCCC";
    const t = clamp01((v - min) / Math.max(1e-6, max - min));
    const light = 95 - t * 60; // light → dark
    return hslToHex(h, s, light);
  };
};



class NZ2026Home extends Component {
      constructor(props) {
    super(props);
    this.state = {
      geoLevel: "constituency",
      metricRows: null, 
      loading: false,
      hoverInfo: null,
      hoverInfoHeatMap: null,
      hoverAreaId: null,
      hoverAreaIdHeatMap: null,
      selectedStateBounds: null,
      selectedFeature: null,   
      geoData:null,
      styleLoaded: false,
      viewState: null,
      metricRowsConst: null,
      metricRowsNational:null,
      chosenGender:null,
      chosenAge:null,
      chosenEthnicity:null,
      chosenEducation:null,
      chosenPV:null,
      chosenHeatParty:"inflation_issue_n",
      user: { email: '', name: '', company: '' },
      anchorEl: null,
      hoveredButton: null,
      constituencyMap :null,
      SA3Map:null,
      SA2Map:null,
      startloading: true  // 👈 new flag

    };
    
    this.mapRef1 = React.createRef();
    this.mapRef2 = React.createRef();
    this._inflight = null; 
    this._lastKey = null;
    this._lastAt = 0;

    
  }

  
  componentDidMount() {
    
    
      axios.get('/api/user-info/')
      .then((response) => {
        this.setState({ user: response.data }, () => {
          console.log("user", this.state.user);
        });
      })
      .catch((error) => {
        console.error('Error fetching user info:', error);
      });
      Promise.all([
        fetch(process.env.PUBLIC_URL + "/NZ_maps/newZealandConstituency.json").then(r => r.json()),
        fetch(process.env.PUBLIC_URL + "/NZ_maps/newZealandSA3.json").then(r => r.json()),
        fetch(process.env.PUBLIC_URL + "/NZ_maps/newZealandSA2.json").then(r => r.json())
        ]).then(([constituencyData, sa3Data, sa2Data

        ]) => {
        const makeGeo = (data) => ({
            type: "FeatureCollection",
            features: (data.features || []).map(f => ({
            ...f,
            properties: { ...f.properties }
            }))
        });

        this.setState({
            constituencyMap: makeGeo(constituencyData),
            SA3Map: makeGeo(sa3Data),
            SA2Map: makeGeo(sa2Data),
  geoData: makeGeo(constituencyData),
        startloading: false   // 👈 maps are ready
        });
        });
      

  const run = async () => {
    await this.fetchMetrics("national", null, true);
    await this.fetchMetrics("constituency", null, true);
  };
  run();
}



  componentWillUnmount() {
    window.removeEventListener('popstate', this._onPopState);
  };


   componentDidUpdate(prevProps, prevState) {
    const groupChanged      = prevProps.selectedGroupId !== this.state.selectedGroupId;
   
    const levelChanged      = prevState.geoLevel !== this.state.geoLevel;

    
    const chosenGenderChanged      = prevState.chosenGender !== this.state.chosenGender;
    const chosenAgeChanged      = prevState.chosenAge !== this.state.chosenAge;
    const chosenEthnicityChanged      = prevState.chosenEthnicity !== this.state.chosenEthnicity;
    const chosenEducationChanged      = prevState.chosenEducation !== this.state.chosenEducation;
    
    const chosenGenderPVChanged      = prevState.chosenPV !== this.state.chosenPV;
    const filtersChanged = chosenGenderChanged || chosenAgeChanged || chosenEthnicityChanged ||chosenGenderPVChanged ||chosenEducationChanged


  
    const needRefetch = levelChanged  || groupChanged ||filtersChanged;
    if (needRefetch) {
        const run = async () => {
   // await this.fetchMetrics("constituency", null, true);
    await this.fetchMetrics(this.state.geoLevel, this.state.selectedFeature?.area_id);
    };
    run();
    }

  
    const rowsChanged  = prevState.metricRows !== this.state.metricRows;
    const geoChanged   = prevState.geoData !== this.state.geoData;
    const chosenHeatPartyChanged   = prevState.chosenHeatParty !== this.state.chosenHeatParty;
  
    if (geoChanged || rowsChanged || groupChanged||filtersChanged||chosenHeatPartyChanged) {
      this.restyle();
    }
  
   
    
  }
  _inflightBaseline = null;
  _lastBaselineKey = null;
  _lastBaselineAt = 0;
    requestKey = (level) => {

    return `${level}`;
  };


  //main function that grabs data
    fetchMetrics = async (level, constCode, save_const_results) => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;

  const reqKey = this.requestKey(level);
  const now = Date.now();
  if (this._lastKey === reqKey && now - this._lastAt < 700) return;
  this._lastKey = reqKey;
  this._lastAt = now;


    let keysBody 
    if(level==="national"||save_const_results){
          keysBody= [


                     "inflation_issue_n",
                    "health_issue_n",
                    "econ_issue_n",
                    "crime_issue_n",
                    "housing_issue_n",
                    "poverty_issue_n",
                    "unemployment_issue_n",
                    "climate_issue_n",
                    "education_issue_issue_n",
                    "transport_issue_n",
                    "drugs_issue_n",
                    "race_rel_issue_n",
                    "tax_issue_n",
                    "pollution_issue_n",
                    "maori_issue_n",
                    "immigration_issue_n",
                    "defence_issue_n",
                    "turnout_1_p",
                    "n_raked"
                  ]  
    }else{
    keysBody= [


                     "inflation_issue_n",
                    "health_issue_n",
                    "econ_issue_n",
                    "crime_issue_n",
                    "housing_issue_n",
                    "poverty_issue_n",
                    "unemployment_issue_n",
                    "climate_issue_n",
                    "education_issue_issue_n",
                    "transport_issue_n",
                    "drugs_issue_n",
                    "race_rel_issue_n",
                    "tax_issue_n",
                    "pollution_issue_n",
                    "maori_issue_n",
                    "immigration_issue_n",
                    "defence_issue_n",
                    "turnout_1_p",
                    "n_raked"
                  ]
                }
                
                
     let turnout_weight
    turnout_weight = "turnout_1_n"

    const body = {
      groupKeys: keysBody,
      filters: {
      gender: this.state.chosenGender ?? null,     
      age: this.state.chosenAge ?? null,            
      ethnicity: this.state.chosenEthnicity ?? null,
      education: this.state.chosenEducation ??null,
      vote_2023: this.state.chosenPV ?? null,     
    },
      constCode: constCode,
      turnout_weight:turnout_weight
    };
    this.setState({ loading: true });
 
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/${level}_data_arrow/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);

      // --- update state with both ---
      if(save_const_results){
        if(level==="national"){
          this.setState(
             { metricRowsNational: rowsMain,
               
        loading: false, })
            }else{
            this.setState(
            { metricRowsConst: rowsMain ,
               metricRows: this.state.metricRows===null ? rowsMain :this.state.metricRows,
               
        loading: false,
            })
            }
      }else{
           this.setState({
        metricRows: rowsMain,
        loading: false,
        
      });
      }
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ metricRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }

   restyle = () => {
    const { geoData, metricRows} = this.state;  

    if (!geoData) {
      this.setState({ styledGeo: null,
                      styledGeoHeatMap: null,

       });
      return;
    }
      if (!metricRows) {
      return;
    }
    const pastVoteCols = [
    "past_vote_act",
    "past_vote_green",
    "past_vote_lab",
    "past_vote_nat",
    "past_vote_nzf",
    "past_vote_oth",
    "past_vote_tpm"
  ];

  // Normalise values within each row so these columns sum to 100
  const normalisedRows = metricRows.map(row => {
    // Compute the sum of selected columns
    const sum = pastVoteCols.reduce((acc, col) => acc + (parseFloat(row[col]) || 0), 0);

    // Only normalise if the sum is positive
    if (sum > 0) {
      const newRow = { ...row };
      for (const col of pastVoteCols) {
        newRow[col] = (parseFloat(row[col]) || 0) / sum * 100;
      }
      return newRow;
    }
    return row;
  });
    const byId = new Map();
    for (const r of normalisedRows) {
      const id = String(r.area_id ?? "");
      if (id) byId.set(id, r);
    }


    /// FIRST DO EVERYTHING FOR THE NORMAL MAP

 
    const { labels, colors } = buildLabelsAndColors();

    const styled = {
      type: "FeatureCollection",
      features: geoData.features.map(f => {
        const rid = String(f.properties?.area_id ?? "");
        const row = byId.get(rid);
        
  
        if (!row) {
          return {
            ...f,
            properties: {
              ...f.properties,
              fillColor: "#ffffff",
              topLabel: "No data",
              topValue: 0,
              _allValues: {},
              _allValuesSorted: [],
            }
          };
        }
        const groupKeys = [
             "inflation_issue_n",
                    "health_issue_n",
                    "econ_issue_n",
                    "crime_issue_n",
                    "housing_issue_n",
                    "poverty_issue_n",
                    "unemployment_issue_n",
                    "climate_issue_n",
                    "education_issue_issue_n",
                    "transport_issue_n",
                    "drugs_issue_n",
                    "race_rel_issue_n",
                    "tax_issue_n",
                    "pollution_issue_n",
                    "maori_issue_n",
                    "immigration_issue_n",
                    "defence_issue_n",
            ]
  
        const displayKeys = (groupKeys || []).filter(k => k in row);
        if (displayKeys.length === 0) {
          return {
            ...f,
            properties: {
              ...f.properties,
              fillColor: "#ffffff",
              topLabel: "No data",
              topValue: 0,
              _allValues: {},
              _allValuesSorted: [],
            }
          };
        }
  
        const entries = displayKeys
          .map(k => ({
            key: k,
            area_name: labels[k] || k,
            area_id: Number(row[k]),
          }))
          .filter(e => Number.isFinite(e.area_id))
          .sort((a, b) => b.area_id - a.area_id);

  
        let fillColor = "#666";
        let topKey    = entries[0]?.key;
        let topLabel  = entries[0]?.area_name || "";
        let topValue  = entries[0]?.area_id || 0;
        fillColor = colors[topKey] || "#000000";

        let sortedvals

           sortedvals = entries
                  .map(e => ({
                    ...e,
                    order: e.key === "Net" ? Number.MAX_SAFE_INTEGER : 0 // net at bottom, others stay in original order
                  }))
                  .sort((a, b) => a.order - b.order)
                  .map(e => ({ key: e.key, area_name: e.area_name, area_id: e.area_id })); // remove order after sorting
     let pastVoteValues = {};
      const sum = pastVoteCols.reduce((acc, col) => acc + (parseFloat(row?.[col]) || 0), 0);
      if (sum > 0) {
        pastVoteValues = Object.fromEntries(
          pastVoteCols.map(col => [col, ((parseFloat(row?.[col]) || 0) / sum) * 100])
        );
      }
        return {
          ...f,
          properties: {
            ...f.properties,
            fillColor,
            topKey,
            topLabel,
            topValue,
            _allValues: Object.fromEntries(entries.map(e => [e.key,e.area_name, e.area_id])),
            _allValuesSorted: sortedvals,
            Turnout: row?.turnout_1_p,
    ...pastVoteValues 
          }
        };
      })
    };


    //// NOW REPEAT FOR THE HEAT MAP

    
    const heatKey = this.state.chosenHeatParty;
    

    const values = geoData.features.map(f => {
      const rid = String(f.properties?.area_id ?? "");
      const row = byId.get(rid);

      

      if(heatKey==="coalition"){

      return row ? Number(row["nat_pred_n"])+Number(row["act_pred_n"]) +Number(row["nzf_pred_n"]): NaN;
      }else{
      return row ? Number(row[heatKey]) : NaN;

      }
 
    });
    

    const base = colors[heatKey] || "#6e6e6e";
    
    const heatScale = makeHeatScale(base, values);
 
    const styledHeatMap = {
      type: "FeatureCollection",
      features: geoData.features.map(f => {
        const rid = String(f.properties?.area_id ?? "");
        const row = byId.get(rid);
        
  
        if (!row) {
          return {
            ...f,
            properties: {
              ...f.properties,
              fillColor: "#ffffff",
              topLabel: "No data",
              topValue: 0,
              _allValues: {},
              _allValuesSorted: [],
            }
          };
        }
        const groupKeys = [
                         "inflation_issue_n",
                    "health_issue_n",
                    "econ_issue_n",
                    "crime_issue_n",
                    "housing_issue_n",
                    "poverty_issue_n",
                    "unemployment_issue_n",
                    "climate_issue_n",
                    "education_issue_issue_n",
                    "transport_issue_n",
                    "drugs_issue_n",
                    "race_rel_issue_n",
                    "tax_issue_n",
                    "pollution_issue_n",
                    "maori_issue_n",
                    "immigration_issue_n",
                    "defence_issue_n",
            ]
  
        const displayKeys = (groupKeys || []).filter(k => k in row);
        if (displayKeys.length === 0) {
          return {
            ...f,
            properties: {
              ...f.properties,
              fillColor: "#ffffff",
              topLabel: "No data",
              topValue: 0,
              _allValues: {},
              _allValuesSorted: [],
            }
          };
        }
  
        const entries = displayKeys
          .map(k => ({
            key: k,
            area_name: labels[k] || k,
            area_id: Number(row[k]),
          }))
          .filter(e => Number.isFinite(e.area_id))
          .sort((a, b) => b.area_id - a.area_id);

  
        let fillColor = "#666";
        let topKey    = entries[0]?.key;
        let topLabel  = entries[0]?.area_name || "";
        let topValue  = entries[0]?.area_id || 0;

        let v;
 
        if(heatKey==="coalition"){
        v  =   Number(row["nat_pred_n"])+Number(row["act_pred_n"]) +Number(row["nzf_pred_n"]);
    }else{
        v = Number(row[heatKey])

    }   


        fillColor = heatScale(v);
        topKey    = heatKey;
        topLabel  = entries[0]?.area_name || "";
        topValue  = Number.isFinite(v) ? v : 0;

        let sortedvals

           sortedvals = entries
                  .map(e => ({
                    ...e,
                    order: e.key === "Net" ? Number.MAX_SAFE_INTEGER : 0 // net at bottom, others stay in original order
                  }))
                  .sort((a, b) => a.order - b.order)
                  .map(e => ({ key: e.key, area_name: e.area_name, area_id: e.area_id })); // remove order after sorting
     
       let pastVoteValues = {};
      const sum = pastVoteCols.reduce((acc, col) => acc + (parseFloat(row?.[col]) || 0), 0);
      if (sum > 0) {
        pastVoteValues = Object.fromEntries(
          pastVoteCols.map(col => [col, ((parseFloat(row?.[col]) || 0) / sum) * 100])
        );
      }
        return {
          ...f,
          properties: {
            ...f.properties,
            fillColor,
            topKey,
            topLabel,
            topValue,
            _allValues: Object.fromEntries(entries.map(e => [e.key,e.area_name, e.area_id])),
            _allValuesSorted: sortedvals,
            Turnout: row?.turnout_1_p,
    ...pastVoteValues 
          }
        };
      })
    };
  
    this.setState({ styledGeo: styled,styledGeoHeatMap: styledHeatMap,styleLoaded: true });
  };

fitBoundsFromFeatures = (features) => {
  // Ensure both maps exist
  if (!this.mapRef1?.current || !this.mapRef2?.current || !features?.length) return null;

  const map1 = this.mapRef1.current.getMap?.();
  const map2 = this.mapRef2.current.getMap?.();
  if (!map1 || !map2) return null;

  const bounds = new mapboxgl.LngLatBounds();

  // Handle both GeoJSON and vector-tile features
  features.forEach((f) => {
    let geometry = f.geometry;
    if (f._vectorTileFeature) {
      // Convert vector tile features to GeoJSON for coordinate access
      geometry = f._vectorTileFeature.toGeoJSON(f._x, f._y, f._z).geometry;
    }

    // Recursively walk all coordinates (Polygon / MultiPolygon)
    const walk = (coords) => {
      if (typeof coords[0] === "number") {
        bounds.extend(coords);
      } else {
        coords.forEach(walk);
      }
    };

    if (geometry?.coordinates) walk(geometry.coordinates);
  });

  // Only apply zoom if bounds are valid
  if (!bounds.isEmpty()) {
    [map1, map2].forEach((map) => {
      map.fitBounds(bounds, { padding: 80, duration: 500 });
    });
  } else {
    console.warn("No valid bounds from features:", features);
  }

  return bounds;
};

  

   onMapClick = (evt) => {
  const feature = evt.features?.[0];
  if (!feature) return;

  const level = this.state.geoLevel;
  const p = feature.properties || {};
  const areaId = String(p.area_id ?? "");

  const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);

  // Handle deselection (if user clicks same feature twice)
  if (
    areaId &&
    this.state.selectedFeature &&
    this.state.selectedFeature.level === level &&
    this.state.selectedFeature.area_id === areaId
  ) {
    this.setState({ selectedFeature: null }, () => {
      const { selectedStateBounds } = this.state;
      const map1 = this.mapRef1.current?.getMap?.();
      const map2 = this.mapRef2.current?.getMap?.();

      if (selectedStateBounds && map1 && map2) {
        [map1, map2].forEach((map) => {
          map.fitBounds(selectedStateBounds, { padding: 80, duration: 500 });
        });
      }

      this.state.onFeatureSelect?.({
        feature: null,
        selectedAreaLabel: null,
        selectedFeatureLevel: null,
      });
    });
    return;
  }

  // When a constituency is clicked → zoom and drill down to SA3
  if (level === "constituency") {
    const constCode = String(p.area_id || "");
    if (!constCode) return;

    const stateBounds = zoomToFeature(feature); // 👈 this syncs both maps
    const stateLabel = p.area_name;

    this.setState(
      {
        selectedconstCode: constCode,
        selectedStateBounds: stateBounds,
        geoLevel: "SA3",
        selectedFeature: {
          level: "constituency",
          key: "area_id",
          area_id: constCode,
          area_name: stateLabel,
          rowMatchIds: [constCode],
        },
      },
      () => {
        // Fetch metrics and new geo for that area
        this.fetchMetrics("SA3", constCode);
        this.loadGeo("SA3", { doFit: false });
      }
    );
  }
};

    onMouseMove = (evt) => {
        const feature = evt.features && evt.features[0];
        if (!feature) return this.setState({ hoverInfo: null,hoverAreaId:null });
    
        const { lng, lat } = evt.lngLat; 
        this.setState({
        hoverInfo: { lon: lng, lat, props: feature.properties },
        hoverAreaId: feature.properties.area_id ?? null
        });
    };

  loadGeo = async (level) => {
    let newGeo 
    switch(level){
        case "constituency":
         newGeo = this.state.constituencyMap
        break
        case "SA3":
         newGeo = this.state.SA3Map
        break
        case "SA2":
         newGeo = this.state.SA2Map
        break
        default:
         newGeo = this.state.constituencyMap
        break
    }
    this.setState({geoData: newGeo, geoLevel: level
    })
  }

 onGeoLevelChange = (newLevel) => {
  if (!newLevel) return;

  // if these are async functions already, await them
  this.fetchMetrics(newLevel, this.state.selectedFeature?.area_id);
  this.loadGeo(newLevel);

  // return when both finish
};
    // Utility: compute bounds [minX, minY, maxX, maxY] from a FeatureCollection
getFeatureCollectionBounds = (featureCollection) => {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

  featureCollection.features.forEach((feat) => {
    const coords = feat.geometry.coordinates;

    const recurse = (arr) => {
      if (typeof arr[0] === "number") {
        const [x, y] = arr;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      } else {
        arr.forEach(recurse);
      }
    };

    recurse(coords);
  });

  return [[minX, minY], [maxX, maxY]];
};
    

   resetView = ({ LevelToResetTo = "constituency" }) => {
    const map1 = this.mapRef1.current?.getMap();
    const map2 = this.mapRef2.current?.getMap();
      if (map1) {
    map1.fitBounds(
      [
        [166.0, -47.5], // SW
        [179.0, -33.0], // NE
      ],
      { padding: 80 }
    );
  }
   if (map2) {
    map2.fitBounds(
      [
        [166.0, -47.5], // SW
        [179.0, -33.0], // NE
      ],
      { padding: 80 }
    );
  }

  this.setState(
    {
      geoLevel: LevelToResetTo,
      selectedStateCode: null,
      selectedStateBounds: null,
      selectedFeature: null,
      metricRows: null,
      styledGeo: null,
      
    },
    () => {
      this.onGeoLevelChange(LevelToResetTo);

    }
  );
};

handleselectedFeatureChange =  (area_id, area_name) => {



    const feature = this.state.constituencyMap.features.filter(
          f => String(f.properties.area_id) === String(area_id.area_id)
        )[0];
    if (!feature) return;
    const level = this.state.geoLevel;
    const p = feature.properties || {};
    const areaId = String(p.area_id ?? "");
    const map1 = this.mapRef1.current?.getMap();
    const map2= this.mapRef2.current?.getMap();

    const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);   

    const clickedLevel = level;


    if (
      areaId &&
      this.state.selectedFeature &&
      this.state.selectedFeature.level === clickedLevel &&
      this.state.selectedFeature.area_id === areaId
    ) {
      this.setState({ selectedFeature: null }, () => {
        if (this.state.selectedStateBounds) {
          map1?.fitBounds(this.state.selectedStateBounds, { padding: 80, duration: 500 });
          map2?.fitBounds(this.state.selectedStateBounds, { padding: 80, duration: 500 });
        } else {
         // map?.fitBounds([[-125, 24], [-66, 49]], { padding: 20, duration: 500 });
        }

        this.state.onFeatureSelect?.({
          feature: null,
          selectedAreaLabel: null,
          selectedFeatureLevel: null,
        });
      });
      return;
    }
      const stateBounds = zoomToFeature(feature); // sets map to state

      const constCode = String(p.area_id || "")
      if (!constCode) return;
  
      const stateLabel =  p.area_name;
  
      this.setState(
        {
          selectedconstCode: constCode,
          selectedStateBounds: stateBounds,
          geoLevel: "SA3",
          viewState:null,
          // Keep selectedFeature pointing to the state context
          selectedFeature: {
            level: "constituency",
            key: "area_id",
            area_id: constCode,
            area_name: stateLabel,
            rowMatchIds: [constCode],
            
          },
        },
        () => {
          // Make sure county metrics (and secondary metrics) are loaded for tooltips
          this.fetchMetrics("SA3",constCode );
          // Load county geo for that state (no auto-fit; we already zoomed)
          this.loadGeo("SA3", { doFit: false });
                
  
        }
      );
      return;
    

    
}

 handlechosenGenderChange     = (val) => this.setState({ chosenGender: val });
 handlechosenAgeChange     = (val) => this.setState({ chosenAge: val });
 handlechosenEthnicityChange     = (val) => this.setState({ chosenEthnicity: val });
 handlechosenEducationChange     = (val) => this.setState({ chosenEducation: val });
 handlechosenPVChange     = (val) => this.setState({ chosenPV: val });
 handlechosenHeatPartyChange     = (val) => this.setState({ chosenHeatParty: val });
   

  render() {
    const {
    //   isPanelOpen,
       selectedSection,
       startloading,
       SA2Map,
       SA3Map,
       constituencyMap

    } = this.state;

       if (startloading) {
      // 👇 loading screen
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <CircularProgress />
        </div>
      );
    }
        // 👇 Restriction logic
    if (!this.state.user.email.includes("stackdatastrategy")) {
        console.log("this.state.user",this.state.user)
      return <Navigate to="/NZ2026" replace />;
    }
  return(
    
    <>
    <Box sx={{ display: 'flex', height: '8vh'}}>
            <Box
              component="main"
              sx={(theme) => ({
                flexGrow: 1,
                backgroundColor: theme.vars
                  ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                  : alpha(theme.palette.background.default, 1),
                overflow: 'hidden',
                display: 'flex',
                width: '50%',
                flexDirection: 'column',
              })}
            >
             
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  px: 2,
                  py: 1,
                  borderBottom: '3px solid',
                  borderColor: '#000000',
                }}
              >
                <img
                  src={process.env.PUBLIC_URL + '/static/images/stack_logo.png'}
                  alt="District Profiles"
                  style={{ height: 50, objectFit: 'contain' }}
                />
    
              </Box>
            </Box>
     </Box>
    <Box
    width="100%"
    height='92vh'
  sx={{
    display: "grid",
    gridTemplateColumns: "0.15fr 0.60fr 0.25fr",
    gap: 2, // optional
  }}
>
  <Box>     
     <Stack direction="column"  alignItems="left" sx={{ ml: 4, mt:10 }}>

        
          <Typography variant="h5" fontWeight={700}>Demograhpic Breakdown</Typography>
          <Typography variant="body1" color="text.secondary" sx={{mt:2}}>
            You can use the filters below to construct demographic profiles, then drill down into the issue landscape in different areas by selecting an Electorate.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{mt:15}}>
            Build a demographic profile:
          </Typography>
          <TextField
                select
                label="Gender"
                size="small"
                value={this.state.chosenGender}
                onChange={(e) => this.handlechosenGenderChange?.(e.target.value)}
                sx={{ mt: 3, minWidth: 180 }}
                >
                <MenuItem value={null}>All</MenuItem>
                <MenuItem value="M">Male</MenuItem>
                <MenuItem value="F">Female</MenuItem>
                </TextField>

                <TextField
                select
                label="Age"
                size="small"
                value={this.state.chosenAge}
                onChange={(e) => this.handlechosenAgeChange?.(e.target.value)}
                sx={{ mt: 3, minWidth: 180 }}
                >
                <MenuItem value={null}>All</MenuItem>
                <MenuItem value="Young">Young</MenuItem>
                <MenuItem value="Middle">Middle</MenuItem>
                <MenuItem value="Old">Old</MenuItem>
                </TextField>

                
                <TextField
                select
                label="Education"
                size="small"
                value={this.state.chosenEducation}
                onChange={(e) => this.handlechosenEducationChange?.(e.target.value)}
                sx={{ mt: 3, minWidth: 180 }}
                >
                <MenuItem value={null}>All</MenuItem>
                <MenuItem value="High">High</MenuItem>
                <MenuItem value="Mid">Mid</MenuItem>
                <MenuItem value="Low">Low</MenuItem>
                </TextField>

                <TextField
                select
                label="Ethnicity"
                size="small"
                value={this.state.chosenEthnicity}
                onChange={(e) => this.handlechosenEthnicityChange?.(e.target.value)}
                sx={{ mt: 3, minWidth: 180 }}
                >
                <MenuItem value={null}>All</MenuItem>
                <MenuItem value="Asian only">Asian only</MenuItem>
                <MenuItem value="European only">European only</MenuItem>
                <MenuItem value="European/Māori">European/Māori</MenuItem>
                <MenuItem value="Māori only">Māori only</MenuItem>
                <MenuItem value="Pacific Peoples only">Other</MenuItem>
                </TextField>

                <TextField
                select
                label="2023 Vote"
                size="small"
                value={this.state.chosenPV}
                onChange={(e) => this.handlechosenPVChange?.(e.target.value)}
                sx={{ mt: 3, minWidth: 180 }}
                >
                <MenuItem value={null}>All</MenuItem>
                <MenuItem value="ACT">ACT 2023</MenuItem>
                <MenuItem value="GREEN">Green 2023</MenuItem>
                <MenuItem value="LAB">Labour 2023</MenuItem>
                <MenuItem value="NAT">National 2023</MenuItem>
                <MenuItem value="NZF">NZF 2023</MenuItem>
                <MenuItem value="TPM">TPM 2023</MenuItem>
               <MenuItem value="OTH">Other 2023</MenuItem>
                <MenuItem value="DNV">Did not vote</MenuItem>
                </TextField>

       </Stack>
    </Box>
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",     // make sure this column fills available height
            }}
            >
             <Stack direction="column"  alignItems="left" sx={{ mt:10 }}>

        
          <Typography variant="h5" fontWeight={700}>Top issue</Typography>
          <Typography variant="body1" color="text.secondary" sx={{mt:2}}>
            Select an Electorate from the drop-down menu,or click on a block below to zoom in on the map
          </Typography>
          </Stack>

            <Box
                sx={{
                mt: "auto",       // pushes this box to the bottom
                height: "80%",    // give it a height
                mb:1,
                display: "flex",
                alignContent:"center",
                justifyContent:"center",
                alignItems:"center",
                justifyItems:"center"
                }}
            >
           <MapComponent
                    mapRef={this.mapRef1}
                    styledGeo={this.state.styledGeo}
                    geoData={this.state.geoData}
                    hoverInfo={this.state.hoverInfo}
                    styleLoaded={this.state.styleLoaded}
                    selectedFeature={this.state.selectedFeature}
                    onMapClick={this.onMapClick}
                    onMouseMove={this.onMouseMove}
                    onGeoLevelChange={this.onGeoLevelChange}
                    buildLabelsAndColors={buildLabelsAndColors}
                    geoLevel={this.state.geoLevel}
                    resetView={this.resetView}
                    handleselectedFeatureChange={this.handleselectedFeatureChange}
                    viewState={this.state.viewState}
                    tooltip="InternalMain"
                    tooltip_pastcomp="no"
                />

                {this.state.loading && (
                    <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(255, 255, 255, 0.6)", // semi-transparent overlay
                        zIndex: 10,
                    }}
                    >
                    <CircularProgress />
                    </Box>
  )}
               
            </Box>
            </Box>
            <Box>
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",     // make sure this column fills available height
                px:1,
                py:1 ,   
                 justifyContent: "flex-end", // push everything to the bottom
            }}
            >
              <Stack direction="column" alignItems="flex-start" sx={{ mb: 2 }} width="100%">
                    <Typography variant="h5" fontWeight={700}>Individual issues</Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
                    Select an issue to view, on the heat map below, its prominence across the country within the selected demographic profile
                    </Typography>

                <Box sx={{ mt: 2, mb: 1, display: "flex", flexWrap: "wrap", gap: 1 }}>
                {Object.entries(PARTY_INFO).map(([key, { name, color }]) => {
                    const isSelected = this.state.chosenHeatParty === key;
                    return (
                    <Button
                        key={key}
                        variant="outlined"
                        onClick={() => this.handlechosenHeatPartyChange?.(key)}
                             sx={{
          backgroundColor: isSelected ? "#FFFFFF" : color,
          color: isSelected ? "black" : "#FFFFFF",
          border: `2px solid ${color}`,
          textTransform: "none",
          fontSize: "0.8rem",
          fontWeight: 500,
          boxShadow: "none",
          "&:hover": {
            backgroundColor: isSelected ? "#FFFFFF" : color,
            opacity: 0.85,
            boxShadow: "0 0 6px rgba(0,0,0,0.15)",
          },
        }}
                    >
                        {name}
                    </Button>
                    );
                })}
                </Box>
   
                </Stack>

            <Box
                sx={{
                height: "50%",    // give it a height
                display: "flex",
                alignContent:"center",
                justifyContent:"center",
                alignItems:"center",
                justifyItems:"center"
                }}
            >
           
                <MapComponent
                mapRef={this.mapRef2}
                styledGeo={this.state.styledGeoHeatMap}
                geoData={this.state.geoData}
                hoverInfo={this.state.hoverInfo}
                styleLoaded={this.state.styleLoaded}
                selectedFeature={this.state.selectedFeature}
                onMapClick={this.onMapClick}
                onMouseMove={this.onMouseMove}
                onGeoLevelChange={this.onGeoLevelChange}
                buildLabelsAndColors={buildLabelsAndColors}
                geoLevel={this.state.geoLevel}
                resetView={this.resetView}
                handleselectedFeatureChange={this.handleselectedFeatureChange}
                viewState={this.state.viewState}
                tooltip="InternalHeat"
                tooltip_pastcomp="no"
                smallMap="yes"
            chosenParty = {this.state.chosenHeatParty}
            chosenView={"pred"}
                />
              
                {this.state.loading && (
                    <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(255, 255, 255, 0.6)", // semi-transparent overlay
                        zIndex: 10,
                    }}
                    >
                    <CircularProgress />
                    </Box>
  )}
            </Box>
        </Box>

 
    </Box>
    </Box>

</>

  )
}


  }

export default withRouter(NZ2026Home);